export default __webpack_public_path__ + "static/media/prelaunch.92fda6d1.png";